const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Boolean',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field has-checkbox-with-label pb-1 mb-0 {~ColumnAlignment:Record~}">
					<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
						<p class="control control-status">
							<span class="control-status-icon"></span>
							<input
								id="{~D:Record.Macro.RawHTMLID~}"
								type="checkbox"
								class="is-checkbox"
								{~D:Record.Macro.ControlAttr~}
								{~Required:Record~}
								{~Disabled:Record~}
								{~D:Record.Macro.InputFullProperties~}
								{~D:Record.Macro.InputChangeHandler~}
								value=""
							/>
							<span class="{~HideLabel:Record~}">{~LabelWithChips:Record~}</span>
						</p>
					</label>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Boolean',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-checkbox-with-label pb-1 mb-0 mt-2 {~ColumnAlignment:Record~}">
							<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
								<p class="control control-status">
									<span class="control-status-icon"></span>
									<input
										id="{~D:Record.Macro.RawHTMLID~}"
										type="checkbox"
										class="is-checkbox"
										{~D:Record.Macro.ControlAttr~}
										{~Required:Record~}
										{~Disabled:Record~}
										{~D:Record.Macro.InputFullProperties~}
										{~D:Record.Macro.InputChangeHandler~}
										value=""
									/>
								</p>
							</label>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Boolean',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.InputType~} -->
			<div class="field has-checkbox-with-label pb-1 mb-0 {~ColumnAlignment:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							type="checkbox"
							class="is-checkbox"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							{~D:Record.Macro.HTMLName~}
							{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Boolean',
			Template: /*HTML-Partial*/`
							value=""
						/>
						<span class="{~HideCheckboxInlineLabel:Record~}">{~LabelWithChips:Record~}</span>
					</p>
				</label>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Boolean',
			Template: /*HTML*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field has-checkbox-with-label pb-1 mb-0 {~ColumnAlignment:Record~}">
					<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="checkbox"
							class="is-checkbox"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
							value=""
						/>
						<span class="{~HideLabel:Record~}">{~LabelWithChips:Record~}</span>
					</label>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Boolean',
			Template: /*HTML*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="checkbox"
									class="is-checkbox"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									disabled="disabled"
									value=""
								/>
							</label>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Boolean',
			Template: /*HTML-Partial*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.InputType~} -->
			<div class="field has-checkbox-with-label pb-1 mb-0 {~ColumnAlignment:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							type="checkbox"
							class="is-checkbox"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.HTMLName~}
							{~D:Record.Macro.InformaryTabular~}
							disabled="disabled"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Boolean',
			Template: /*HTML-Partial*/`
							value=""
						/>
						<span class="{~HideCheckboxInlineLabel:Record~}">{~LabelWithChips:Record~}</span>
					</p>
				</label>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Boolean',
			Template: /*HTML*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field has-checkbox-with-label pb-1 mb-0 {~ColumnAlignment:Record~}">
					<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="checkbox"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<span class="{~HideLabel:Record~}">{~LabelWithChips:Record~}</span>
					</label>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Boolean',
			Template: /*HTML*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
							<input
								id="{~D:Record.Macro.RawHTMLID~}"
								type="checkbox"
								{~D:Record.Macro.ControlAttr~}
								{~D:Record.Macro.InputFullProperties~}
								value=""
							/>
							<span class="{~HideLabel:Record~}">{~LabelWithChips:Record~}</span>
						</label>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Boolean',
			Template: /*HTML-Partial*/`
			<!-- InputType Boolean {~D:Record.Hash~} {~D:Record.InputType~} -->
			<div class="field has-checkbox-with-label pb-1 mb-0 {~ColumnAlignment:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label checkbox">
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="checkbox"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Boolean',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<span class="{~HideCheckboxInlineLabel:Record~}">{~LabelWithChips:Record~}</span>
				</label>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
